<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("edit") }} {{ $t("seatreservationtype") }}
      </div>
      <router-link class="btn-blue" to="seat-reservation-types"
        >{{ $t("seatreservationtype") }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div
          v-for="(item, index) in SeatReserveTypes"
          :key="index"
          v-if="item.fieldname !== 'srt_id' && item.type !== 'file'"
          class="col-lg-6 col-xl-3 align-self-center mb-4"
        >
          <div v-if="item.type !== 'radio' && item.type !== 'file'">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  @focus="onFocusHandler"
                  :type="item.type"
                  :name="item.fieldname"
                  :id="item.fieldname"
                  v-validate="item.validation"
                  v-model="item.fieldvalue"
                  placeholder="."
                />
                <label>{{ $tc(item.label, 1) }}</label>
              </div>
              <!-- <Tooltip :title="$t(item.tooltip)" /> -->
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has(item.fieldname)">{{
                errors.first(`${item.fieldname}`)
              }}</span>
            </p>
          </div>

          <div v-if="item.fieldname === 'srt_multi_select'">
            <div class="d-flex align-items-center">
              <label class="mb-0 mr-3">{{ $t("srt_multi_select") }}</label>
              <!-- <label class="ios-switch"> -->
              <b-form-checkbox
                type="checkbox"
                class="j-checkbox"
                v-model="item.fieldvalue"
              />
              <!-- <span class="switch-slider"></span>
              </label> -->
            </div>
            <p class="error_message">
              <span></span>
            </p>
          </div>
          <div v-if="item.fieldname === 'srt_is_active'">
            <div class="d-flex align-items-center">
              <label class="mb-0 mr-3">{{ $t("active") }}</label>
              <!-- <label class="ios-switch"> -->
              <b-form-checkbox
                type="checkbox"
                class="j-checkbox"
                v-model="item.fieldvalue"
              />
              <!-- <span class="switch-slider"></span>
              </label> -->
            </div>
            <p class="error_message">
              <span></span>
            </p>
          </div>
        </div>

        <!-- WIP ON COLLAPSE -->

        <div class="section-wrapper col-12 mb-4">
          <div
            class="sectionName border-bottom d-flex justify-content-between section-header-border"
            :class="!collapseObj.dash ? 'section_full_border' : ''"
          >
            <div
              class="fs-17 font-weight-bold section-header-name"
              @click="collapseObj.dash = !collapseObj.dash"
            >
              DashBoard Seat Icon Uploads
            </div>
            <span
              class="icon-collapse-up blue-icon mx-1 btn float-right"
              style="height: 30px"
              v-if="collapseObj.dash"
              @click="collapseObj.dash = !collapseObj.dash"
            ></span>
            <span
              class="icon-collapse blue-icon mx-1 btn float-right"
              style="height: 30px"
              v-if="!collapseObj.dash"
              @click="collapseObj.dash = !collapseObj.dash"
            ></span>
          </div>
          <b-collapse
            v-model="collapseObj.dash"
            class="pt-2 px-2 collapse-container"
          >
            <div class="row py-3">
              <div class="d-flex align-items-center col-md-4">
                <label :for="'srt_dash_image_url'" class="file-selector w-100">
                  <label
                    class="file-selector-label"
                    :class="srt_dash_image_url ? 'shift-up' : ''"
                    >{{ $t("srt_dash_image_url") }}</label
                  >
                  <span class="text-truncate">{{ srt_dash_image_url }}</span>
                  <input
                    type="file"
                    :name="'srt_dash_image_url'"
                    :id="'srt_dash_image_url'"
                    placeholder="."
                    class="d-none"
                    v-on:change="
                      setImage(
                        $event,
                        'srt_dash_image_url',
                        getFieldItemIndex('srt_dash_image_url'),
                        getFieldItemIndex('srt_dash_image_url')
                      )
                    "
                  />
                </label>
                <div
                  class="restore blue-icon mx-1 btn float-right"
                  @click="restoreDefaultIcon('srt_dash_image_url')"
                ></div>
                <div class="col-2 align-self-center">
                  <img
                    width="40"
                    height="40"
                    class="rounded preview-sm-icon"
                    @click="showImage('srt_dash_image_url')"
                    :src="_GetImagePath(srt_dash_image_url)"
                    v-if="srt_dash_image_url"
                  />
                  <img
                    v-else
                    width="35"
                    height="35"
                    class="rounded"
                    alt="Empty Image"
                    src="@/assets/img/icons/empty-image.svg"
                  />
                </div>
              </div>

              <div class="d-flex align-items-center col-md-4">
                <label
                  :for="'srt_dash_image_url_selected'"
                  class="file-selector w-100"
                >
                  <label
                    class="file-selector-label"
                    :class="srt_dash_image_url_selected ? 'shift-up' : ''"
                    >{{ $t("srt_dash_image_url_selected") }}</label
                  >
                  <span class="text-truncate">{{
                    srt_dash_image_url_selected
                  }}</span>
                  <input
                    type="file"
                    :name="'srt_dash_image_url_selected'"
                    :id="'srt_dash_image_url_selected'"
                    placeholder="."
                    class="d-none"
                    v-on:change="
                      setImage(
                        $event,
                        'srt_dash_image_url_selected',
                        getFieldItemIndex('srt_dash_image_url_selected'),
                        getFieldItemIndex('srt_dash_image_url_selected')
                      )
                    "
                  />
                </label>
                <div
                  class="restore blue-icon mx-1 btn float-right"
                  @click="restoreDefaultIcon('srt_dash_image_url_selected')"
                ></div>
                <div class="col-2 align-self-center">
                  <img
                    width="40"
                    height="40"
                    class="rounded preview-sm-icon"
                    @click="showImage('srt_dash_image_url_selected')"
                    :src="_GetImagePath(srt_dash_image_url_selected)"
                    v-if="srt_dash_image_url_selected"
                  />
                  <img
                    v-else
                    width="35"
                    height="35"
                    class="rounded"
                    alt="Empty Image"
                    src="@/assets/img/icons/empty-image.svg"
                  />
                </div>
              </div>

              <div class="d-flex align-items-center col-md-4">
                <label
                  :for="'srt_dash_image_url_disabled'"
                  class="file-selector w-100"
                >
                  <label
                    class="file-selector-label"
                    :class="srt_dash_image_url_disabled ? 'shift-up' : ''"
                    >{{ $t("srt_dash_image_url_disabled") }}</label
                  >
                  <span class="text-truncate">{{
                    srt_dash_image_url_disabled
                  }}</span>
                  <input
                    type="file"
                    name="srt_dash_image_url_disabled"
                    id="srt_dash_image_url_disabled"
                    placeholder="."
                    class="d-none"
                    v-on:change="
                      setImage(
                        $event,
                        'srt_dash_image_url_disabled',
                        getFieldItemIndex('srt_dash_image_url_disabled'),
                        getFieldItemIndex('srt_dash_image_url_disabled')
                      )
                    "
                  />
                </label>
                <div
                  class="restore blue-icon mx-1 btn float-right"
                  @click="restoreDefaultIcon('srt_dash_image_url_disabled')"
                ></div>
                <div class="col-2 align-self-center">
                  <img
                    width="40"
                    height="40"
                    class="rounded preview-sm-icon"
                    @click="showImage('srt_dash_image_url_disabled')"
                    :src="_GetImagePath(srt_dash_image_url_disabled)"
                    v-if="srt_dash_image_url_disabled"
                  />
                  <img
                    v-else
                    width="35"
                    height="35"
                    class="rounded"
                    alt="Empty Image"
                    src="@/assets/img/icons/empty-image.svg"
                  />
                </div>
              </div>
            </div>
          </b-collapse>
        </div>

        <div class="section-wrapper col-12 mb-4">
          <div
            class="sectionName border-bottom d-flex justify-content-between section-header-border"
            :class="!collapseObj.online ? 'section_full_border' : ''"
          >
            <div
              class="fs-17 font-weight-bold section-header-name"
              @click="collapseObj.online = !collapseObj.online"
            >
              Online Seat Icon Uploads
            </div>
            <span
              class="icon-collapse-up blue-icon mx-1 btn float-right"
              style="height: 30px"
              v-if="collapseObj.online"
              @click="collapseObj.online = !collapseObj.online"
            ></span>
            <span
              class="icon-collapse blue-icon mx-1 btn float-right"
              style="height: 30px"
              v-if="!collapseObj.online"
              @click="collapseObj.online = !collapseObj.online"
            ></span>
          </div>
          <b-collapse
            v-model="collapseObj.online"
            class="pt-2 px-2 collapse-container"
          >
            <div class="row py-3">
              <div class="d-flex align-items-center col-md-4">
                <label
                  :for="'srt_online_image_url'"
                  class="file-selector w-100"
                >
                  <label
                    class="file-selector-label"
                    :class="srt_online_image_url ? 'shift-up' : ''"
                    >{{ $t("srt_online_image_url") }}</label
                  >
                  <span class="text-truncate">{{ srt_online_image_url }}</span>
                  <input
                    type="file"
                    :name="'srt_online_image_url'"
                    :id="'srt_online_image_url'"
                    placeholder="."
                    class="d-none"
                    v-on:change="
                      setImage(
                        $event,
                        'srt_online_image_url',
                        getFieldItemIndex('srt_online_image_url'),
                        getFieldItemIndex('srt_online_image_url')
                      )
                    "
                  />
                </label>
                <div
                  class="restore blue-icon mx-1 btn float-right"
                  @click="restoreDefaultIcon('srt_online_image_url')"
                ></div>
                <div class="col-2 align-self-center">
                  <img
                    width="40"
                    height="40"
                    class="rounded preview-sm-icon"
                    @click="showImage('srt_online_image_url')"
                    :src="_GetImagePath(srt_online_image_url)"
                    v-if="srt_online_image_url"
                  />
                  <img
                    v-else
                    width="35"
                    height="35"
                    class="rounded"
                    alt="Empty Image"
                    src="@/assets/img/icons/empty-image.svg"
                  />
                </div>
              </div>

              <div class="d-flex align-items-center col-md-4">
                <label
                  :for="'srt_online_image_url_selected'"
                  class="file-selector w-100"
                >
                  <label
                    class="file-selector-label"
                    :class="srt_online_image_url_selected ? 'shift-up' : ''"
                    >{{ $t("srt_online_image_url_selected") }}</label
                  >
                  <span class="text-truncate">{{
                    srt_online_image_url_selected
                  }}</span>
                  <input
                    type="file"
                    :name="'srt_online_image_url_selected'"
                    :id="'srt_online_image_url_selected'"
                    placeholder="."
                    class="d-none"
                    v-on:change="
                      setImage(
                        $event,
                        'srt_online_image_url_selected',
                        getFieldItemIndex('srt_online_image_url_selected'),
                        getFieldItemIndex('srt_online_image_url_selected')
                      )
                    "
                  />
                </label>
                <div
                  class="restore blue-icon mx-1 btn float-right"
                  @click="restoreDefaultIcon('srt_online_image_url_selected')"
                ></div>
                <div class="col-2 align-self-center">
                  <img
                    width="40"
                    height="40"
                    class="rounded preview-sm-icon"
                    @click="showImage('srt_online_image_url_selected')"
                    :src="_GetImagePath(srt_online_image_url_selected)"
                    v-if="srt_online_image_url_selected"
                  />
                  <img
                    v-else
                    width="35"
                    height="35"
                    class="rounded"
                    alt="Empty Image"
                    src="@/assets/img/icons/empty-image.svg"
                  />
                </div>
              </div>

              <div class="d-flex align-items-center col-md-4">
                <label
                  :for="'srt_online_image_url_disabled'"
                  class="file-selector w-100"
                >
                  <label
                    class="file-selector-label"
                    :class="srt_online_image_url_disabled ? 'shift-up' : ''"
                    >{{ $t("srt_online_image_url_disabled") }}</label
                  >
                  <span class="text-truncate">{{
                    srt_online_image_url_disabled
                  }}</span>
                  <input
                    type="file"
                    name="srt_online_image_url_disabled"
                    id="srt_online_image_url_disabled"
                    placeholder="."
                    class="d-none"
                    v-on:change="
                      setImage(
                        $event,
                        'srt_online_image_url_disabled',
                        getFieldItemIndex('srt_online_image_url_disabled'),
                        getFieldItemIndex('srt_online_image_url_disabled')
                      )
                    "
                  />
                </label>
                <div
                  class="restore blue-icon mx-1 btn float-right"
                  @click="restoreDefaultIcon('srt_online_image_url_disabled')"
                ></div>
                <div class="col-2 align-self-center">
                  <img
                    width="40"
                    height="40"
                    class="rounded preview-sm-icon"
                    @click="showImage('srt_online_image_url_disabled')"
                    :src="_GetImagePath(srt_online_image_url_disabled)"
                    v-if="srt_online_image_url_disabled"
                  />
                  <img
                    v-else
                    width="35"
                    height="35"
                    class="rounded"
                    alt="Empty Image"
                    src="@/assets/img/icons/empty-image.svg"
                  />
                </div>
              </div>
            </div>
          </b-collapse>
        </div>

        <div class="section-wrapper col-12 mb-4">
          <div
            class="sectionName border-bottom d-flex justify-content-between section-header-border"
            :class="!collapseObj.POS ? 'section_full_border' : ''"
          >
            <div
              class="fs-17 font-weight-bold section-header-name"
              @click="collapseObj.POS = !collapseObj.POS"
            >
              POS Seat Icon Uploads
            </div>
            <span
              class="icon-collapse-up blue-icon mx-1 btn float-right"
              style="height: 30px"
              v-if="collapseObj.POS"
              @click="collapseObj.POS = !collapseObj.POS"
            ></span>
            <span
              class="icon-collapse blue-icon mx-1 btn float-right"
              style="height: 30px"
              v-if="!collapseObj.POS"
              @click="collapseObj.POS = !collapseObj.POS"
            ></span>
          </div>
          <b-collapse
            v-model="collapseObj.POS"
            class="pt-2 px-2 collapse-container"
          >
            <div class="row py-3">
              <div class="d-flex align-items-center col-md-4">
                <label :for="'srt_pos_image_url'" class="file-selector w-100">
                  <label
                    class="file-selector-label"
                    :class="srt_pos_image_url ? 'shift-up' : ''"
                    >{{ $t("srt_pos_image_url") }}</label
                  >
                  <span class="text-truncate">{{ srt_pos_image_url }}</span>
                  <input
                    type="file"
                    :name="'srt_pos_image_url'"
                    :id="'srt_pos_image_url'"
                    placeholder="."
                    class="d-none"
                    v-on:change="
                      setImage(
                        $event,
                        'srt_pos_image_url',
                        getFieldItemIndex('srt_pos_image_url'),
                        getFieldItemIndex('srt_pos_image_url')
                      )
                    "
                  />
                </label>
                <div
                  class="restore blue-icon mx-1 btn float-right"
                  @click="restoreDefaultIcon('srt_pos_image_url')"
                ></div>
                <div class="col-2 align-self-center">
                  <img
                    width="40"
                    height="40"
                    class="rounded preview-sm-icon"
                    @click="showImage('srt_pos_image_url')"
                    :src="_GetImagePath(srt_pos_image_url)"
                    v-if="srt_pos_image_url"
                  />
                  <img
                    v-else
                    width="35"
                    height="35"
                    class="rounded"
                    alt="Empty Image"
                    src="@/assets/img/icons/empty-image.svg"
                  />
                </div>
              </div>

              <div class="d-flex align-items-center col-md-4">
                <label
                  :for="'srt_pos_image_url_selected'"
                  class="file-selector w-100"
                >
                  <label
                    class="file-selector-label"
                    :class="srt_pos_image_url_selected ? 'shift-up' : ''"
                    >{{ $t("srt_pos_image_url_selected") }}</label
                  >
                  <span class="text-truncate">{{
                    srt_pos_image_url_selected
                  }}</span>
                  <input
                    type="file"
                    :name="'srt_pos_image_url_selected'"
                    :id="'srt_pos_image_url_selected'"
                    placeholder="."
                    class="d-none"
                    v-on:change="
                      setImage(
                        $event,
                        'srt_pos_image_url_selected',
                        getFieldItemIndex('srt_pos_image_url_selected'),
                        getFieldItemIndex('srt_pos_image_url_selected')
                      )
                    "
                  />
                </label>
                <div
                  class="restore blue-icon mx-1 btn float-right"
                  @click="restoreDefaultIcon('srt_pos_image_url_selected')"
                ></div>
                <div class="col-2 align-self-center">
                  <img
                    width="40"
                    height="40"
                    class="rounded preview-sm-icon"
                    @click="showImage('srt_pos_image_url_selected')"
                    :src="_GetImagePath(srt_pos_image_url_selected)"
                    v-if="srt_pos_image_url_selected"
                  />
                  <img
                    v-else
                    width="35"
                    height="35"
                    class="rounded"
                    alt="Empty Image"
                    src="@/assets/img/icons/empty-image.svg"
                  />
                </div>
              </div>

              <div class="d-flex align-items-center col-md-4">
                <label
                  :for="'srt_pos_image_url_disabled'"
                  class="file-selector w-100"
                >
                  <label
                    class="file-selector-label"
                    :class="srt_pos_image_url_disabled ? 'shift-up' : ''"
                    >{{ $t("srt_pos_image_url_disabled") }}</label
                  >
                  <span class="text-truncate">{{
                    srt_pos_image_url_disabled
                  }}</span>
                  <input
                    type="file"
                    name="srt_pos_image_url_disabled"
                    id="srt_pos_image_url_disabled"
                    placeholder="."
                    class="d-none"
                    v-on:change="
                      setImage(
                        $event,
                        'srt_pos_image_url_disabled',
                        getFieldItemIndex('srt_pos_image_url_disabled'),
                        getFieldItemIndex('srt_pos_image_url_disabled')
                      )
                    "
                  />
                </label>
                <div
                  class="restore blue-icon mx-1 btn float-right"
                  @click="restoreDefaultIcon('srt_pos_image_url_disabled')"
                ></div>
                <div class="col-2 align-self-center">
                  <img
                    width="40"
                    height="40"
                    class="rounded preview-sm-icon"
                    @click="showImage('srt_pos_image_url_disabled')"
                    :src="_GetImagePath(srt_pos_image_url_disabled)"
                    v-if="srt_pos_image_url_disabled"
                  />
                  <img
                    v-else
                    width="35"
                    height="35"
                    class="rounded"
                    alt="Empty Image"
                    src="@/assets/img/icons/empty-image.svg"
                  />
                </div>
              </div>
            </div>
          </b-collapse>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button @click.prevent.stop="onUpdateHandler" class="btn-blue">
            {{ $t("update") }}
          </button>
          <button @click.prevent.stop="resetHandler()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="seat-reservation-types"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
    <b-modal
      size="sm"
      hide-footer
      ref="preview-modal"
      :title="ImageType"
      id="selected-image-preview-modal"
    >
      <img :src="_GetImagePath(previewKey)" class="img-fluid preiew-img-lg" />
    </b-modal>
    <b-modal id="imagecropper" hide-header hide-footer no-close-on-backdrop>
      <label class="h4 text-center">Crop Image</label>
      <button
        class="btn-clearDate float-right"
        v-on:click="hideCropperModal('imagecropper')"
      >
        ✖
      </button>
      <vue-cropper
        ref="cropper"
        :src="imgSrc"
        :viewMode="1"
        :aspect-ratio="175 / 175"
        :cropBoxResizable="true"
        dragMode="none"
        alt="Source Image"
        preview=".preview"
      ></vue-cropper>
      <br />
      <div class="text-center">
        <button class="btn-blue" @click.prevent.stop="cropImage">Save</button>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import MasterService from "@/services/MasterService";
  import SeatReserveTypes from "@/helper/formJSONMaster/SeatReserveTypes";
  import { getDefaultSeatIcons } from "@/helper/seatReservationTypeHelper";
  import VueCropper from "vue-cropperjs";
  import "cropperjs/dist/cropper.css";

  export default {
    components: { VueCropper },
    data() {
      return {
        selectedKey: "",
        srt_dash_image_url: "",
        srt_dash_image_url_disabled: "",
        srt_dash_image_url_selected: "",

        srt_online_image_url: "",
        srt_online_image_url_disabled: "",
        srt_online_image_url_selected: "",

        srt_pos_image_url: "",
        srt_pos_image_url_disabled: "",
        srt_pos_image_url_selected: "",

        collapseObj: {
          dash: true,
          online: true,
          POS: true,
        },
        file: "",
        imgSrc: "",
        cropImg: "",
        filename: "",
        indexofthubmnail: "",
        ImageType: "",
        UploadFor: "",
        selectedImageIndex: "",
        previewKey: "",
        SeatReserveTypes: SeatReserveTypes.ms_seat_reserve_types,

        Methods: SeatReserveTypes.Methods,
        submitted: false,
        srt_id: null,
      };
    },
    beforeMount() {
      // console.log("this.$route.query :", this.$route.query);
      const { id } = this.$route.query;
      if (id) {
        this.srt_id = id;
        this.getEditList(id);
      } else {
        this.$router.go(-1);
      }
    },
    mounted() {},
    methods: {
      restoreDefaultIcon(keyValue, restoreAll = false) {
        let srtObj = {};
        srtObj = getDefaultSeatIcons(this.srt_id);
        if (srtObj) {
          Object.keys(srtObj).map((x) => {
            if (restoreAll) {
              this[x] = srtObj[x];
              let fieldIndex = this.getFieldItemIndex(x);
              this.SeatReserveTypes[fieldIndex].fieldvalue = srtObj[keyValue];
            } else if (keyValue == x) {
              this[keyValue] = srtObj[keyValue];
              let fieldIndex = this.getFieldItemIndex(keyValue);
              this.SeatReserveTypes[fieldIndex].fieldvalue = srtObj[keyValue];
            }
          });
        } else {
          console.log("srtObj is NULL");
        }
      },
      hideCropperModal: function(modal) {
        this.$bvModal.hide("imagecropper");
      },
      getFieldItemIndex(key) {
        let index = null;
        index = this.SeatReserveTypes.findIndex((x) => x.fieldkey == key);
        return index;
      },
      showImage: function(keyValue) {
        console.log("keyValue", keyValue);
        this.ImageType = "Seat Icon";
        this.previewKey = this.$data[keyValue];
        this.$refs["preview-modal"].show();
      },
      setImage: function(e, keyValue, index, uploadtype) {
        this.file = e.target.files[0];
        this.selectedKey = keyValue;
        this.filename = e.target.files[0]["name"];
        this.indexofthubmnail = index;
        this.UploadFor = uploadtype;
        if (this.file.type.indexOf("image/") === -1) {
          this.$toasted.show("Please select an image file");
          return;
        }
        if (typeof FileReader === "function") {
          const reader = new FileReader();
          reader.onload = (event) => {
            this.imgSrc = event.target.result;
            this.$bvModal.show("imagecropper");
            e.target.value = "";
          };
          reader.readAsDataURL(this.file);
        } else {
          // alert("Sorry, FileReader API not supported");
        }
      },
      cropImage() {
        this.$bvModal.hide("imagecropper");
        // get image data for post processing, e.g. upload or setting image src
        this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
        // this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4);
        var block = this.cropImg.split(";");
        // Get the content type of the image
        var contentType = block[0].split(":")[1]; // In this case "image/gif"
        // get the real base64 content of the file
        var realData = block[1].split(",")[1]; // In this case "R0lGODlhPQBEAPeoAJosM...."
        // Convert it to a blob to upload
        var blob1 = this.b64toBlob(realData, contentType);
        this.onThumbnailUpload(blob1, this.filename, this.indexofthubmnail);
      },
      b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || "";
        sliceSize = sliceSize || 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (
          var offset = 0;
          offset < byteCharacters.length;
          offset += sliceSize
        ) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);

          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);

          byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
      },
      onThumbnailUpload: function(image, filename, index) {
        let loader = this.$loading.show();

        let formData = new FormData();
        // formData.append("image", image);
        formData.append("image", image, filename);
        formData.append("imagePath", "Seat Icon");
        MasterService.GlobalUploadImage(formData)
          .then((response) => {
            // console.log("response :", response);
            const { data } = response;
            if (data && data.status) {
              if (this.UploadFor == index) {
                // this[this.selectedKey] = data.path;
                this.$data[this.selectedKey] = data.path;
                // this.SeatReserveTypes[index].srt_dash_image_url = data.path;
                this.SeatReserveTypes[index].fieldvalue = data.path;
              } else {
                this.$data[this.selectedKey] = data.path;
                this.SeatReserveTypes[index].fieldvalue = data.path;
              }
              this.imgSrc = "";
              this.$bvModal.hide("imagecropper");
            } else {
              data["message"] && data["message"]["message"]
                ? this.$toasted.show(data.message.message)
                : this.$toasted.show(
                    data.message ||
                      "Sorry! Something went wrong. kindly contact your administrator"
                  );
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      },
      resetHandler: function() {
        this.SeatReserveTypes.map((x) => {
          if (x.type === "text" || x.type === "date") {
            x.fieldvalue = "";
          } else if (x.type === "radio") {
            x.fieldvalue = true;
          }
        });
      },
      onFocusHandler: function() {
        // this.submitted = false;
      },
      getEditList: function(id) {
        // let params = `id`
        let body = this.getRequestBody("GET", undefined, {
          ...this.Methods,
          params: { id },
        });
        MasterService.GlobalRequest(body)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              console.log("data :");
              let obj = data.details[0];
              this.SeatReserveTypes.map((x) => {
                if (x.type === "radio") {
                  x.fieldvalue = obj[x.fieldname] === "Y" ? true : false;
                } else if (x.type === "date") {
                  x.fieldvalue = this.formatDate(obj[x.fieldname]);
                } else if (x.type == "file") {
                  this[x.fieldkey] = obj[x.fieldname];
                  x.fieldvalue = obj[x.fieldname];
                  // x.fieldvalue = obj.srt_dash_image_url;
                } else {
                  x.fieldvalue = obj[x.fieldname];
                }
              });
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
      onUpdateHandler: function() {
        // let body = this.getRequestBody("PUT", this.SeatReserveTypes, {
        //   ...this.Methods,
        //   params: { id: this.$route.query.id }
        // });
        // MasterService.GlobalRequest(body)
        //   .then(response => {
        //     const { data } = response;
        //     if (data.status) {
        //       console.log("here :", data);
        //       this.$router.push({
        //         path: "/master/seat-reservation-types"
        //       });
        //     } else {
        //       console.log("show error :", data.message);
        //     }
        //   })
        //   .catch(error => {
        //     console.log("show error :", error);
        //   });

        this.submitted = true;
        this.$validator.validate().then((valid) => {
          console.log("valid :", valid);
          if (valid) {
            console.log("valid :", valid);
            let body = this.getRequestBody("PUT", this.SeatReserveTypes, {
              ...this.Methods,
              params: { id: this.$route.query.id },
            });
            console.log("body :", body);

            MasterService.GlobalRequest(body)
              .then((response) => {
                const { data } = response;

                if (data.status) {
                  console.log("here :", data);
                  this.$router.push({
                    path: "/master/seat-reservation-types",
                  });
                } else {
                  console.log("show error :", data.message);
                  this.$toasted.show(Error(data.message));
                }
              })
              .catch((error) => {
                console.log("show error2 :", error);
              });
          } else {
            console.log("else :");
          }
        });
      },
    },
  };
</script>

<style>
  .section-header-border {
    border: 1px solid var(--lightgrey);
    border-radius: 10px 10px 0px 0px;
    padding: 8px;
  }

  .section_full_border {
    border-radius: 10px;
  }

  .collapse-container {
    border-bottom: 1px solid lightgray;
    border-left: 1px solid lightgray;
    border-right: 1px solid lightgray;
    border-radius: 0px 0px 10px 10px;
  }

  .section-header-name {
    font-size: 17px;
    color: var(--primary);
  }

  .preview-sm-icon {
    background: var(--blue);
    object-fit: contain;
    height: 30px;
    width: 30px;
  }

  .preiew-img-lg {
    background: var(--blue);
    border-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/SeatReservationTypeComponents/editSeatReservationType.vue